import months from './months'

export default function getMonthByIndex(monthIndex: number) {
  return months[monthIndex]
}
